import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import { useRoute } from 'hooks/navigation/use-route';
import { useFeatureAccountForm } from 'hooks/use-feature-account-form';
import { AUTH_CAMPAIGN_PARAM_ID } from 'pages/authentication/components/auth-campaigns/constants';
import useAuthCampaign from 'pages/authentication/components/auth-campaigns/hooks/use-auth-campaign';
import LanguageSelector from 'pages/authentication/components/language-selector';
import { ConfirmOtp } from 'pages/authentication/confirm-otp';
import SignUp from 'pages/authentication/sign-up';
import { SignUpPanel } from 'pages/authentication/sign-up-home/sign-up-home.styled';

import AuthTab from './auth-tab';
import useSingleAuth from './use-single-auth';

function SingleAuthTabView() {
  const { email, activeTabKey, handleAuthentication } = useSingleAuth();

  const { featureAccountForm } = useFeatureAccountForm();
  const { params } = useRoute<{ [AUTH_CAMPAIGN_PARAM_ID]?: string }>();
  const campaignIdParam = params[AUTH_CAMPAIGN_PARAM_ID];
  const campaignContent = featureAccountForm?.activeCampaigns?.find(
    campaign => campaign?.campaignId === campaignIdParam
  );
  const { extraFields } = useAuthCampaign({
    campaignId: campaignIdParam,
    campaignContent,
  });

  let TabComponent = (
    <AuthTab onSubmit={handleAuthentication} authCampaignExtraFields={extraFields} />
  );
  if (activeTabKey === 'signUp' && email) {
    TabComponent = <SignUp skipRedirect={false} initialEmail={email} />;
  }
  if (activeTabKey === 'signIn') {
    TabComponent = <ConfirmOtp />;
  }

  return (
    <KeyboardAwareScrollView keyboardShouldPersistTaps="handled">
      <SignUpPanel>
        {TabComponent}
        <LanguageSelector />
      </SignUpPanel>
    </KeyboardAwareScrollView>
  );
}

export default SingleAuthTabView;
